var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dev-tool-afas"},[_c('a-row',{attrs:{"gutter":[16,16]}},[_c('a-col',{attrs:{"span":24}},[_c('dev-tool-afas-buildings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }